__turbopack_context__.v({
  "header-mobile__navigation": "MobileHeader-module__coLQAG__header-mobile__navigation",
  "mobileFooter": "MobileHeader-module__coLQAG__mobileFooter",
});
